import { Constants } from "@eagerdog/constants";
import { IEventRegisterRow } from "../../../services/helper.service.js";

export namespace PWDCAWaterDog {
  export const form: IEventRegisterRow[] = [
    {
      allowDuplicates: false,
      inputs: [
        {
          type: "checkbox",
          multiSelect: false,
          label: Constants.show_type.water_dog,
          options: [
            { value: Constants.dog_class_element.junior_water_dog, id: Constants.dog_class_element.junior_water_dog },
            { value: Constants.dog_class_element.apprentice, id: Constants.dog_class_element.apprentice },
            { value: Constants.dog_class_element.working, id: Constants.dog_class_element.working },
            { value: Constants.dog_class_element.courier, id: Constants.dog_class_element.courier },
            { value: Constants.dog_class_element.master, id: Constants.dog_class_element.master },
          ]
        },
      ]
    },
  ];
}
